import React from "react";
import "./tweet.css";
import TweetEmbed from "react-tweet-embed";

function Women() {
  return (
    <div
      style={{ padding: "0.3rem", backgroundColor: "#b88ccc" }}
      id="women"
      className="women"
    >
      <h1 style={{ margin: "2rem 0", textAlign: "center" }}>Women in Tech </h1>
      <div style={{ display: "flex", margin: "2rem 0" }}>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
            marginRight: "2rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/5.1.jpg"}></img>
          <div>
            <h5 style={{ color: "whitesmoke" }}>
              <br />JebrilSojoud is our first grad to begin working Qualtrics.
              She'll move all the way from Nablus, Palestine to Krakow, Poland
              to start this new role. <br /><br />You make us proud. You will rock it!
            </h5>
            {/* <h6 style={{ marginLeft: "20rem", color: "whitesmoke" }}>
              ~ Brian Kiely
            </h6> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/5.2.jpg"}></img>
          <div style={{ margin: "2rem 0" }}>
            <h5 style={{ color: "whitesmoke" }}>
              "My time in Manara coincided with war. I am 22 years old. I
              have lived through four wars [but] I was determined to stick to
              the career plan I had before the war." <br /><br />Read Rula's story here:
              https://t.co/DQASJC8oco?amp=1
            </h5>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", margin: "2rem 0" }}>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
            marginRight: "2rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/5.3.jpg"}></img>
          <div>
            <h5 style={{ color: "whitesmoke" }}>
              Thanks to Gold sponsor NAB, we can continue to inspire girls to
              consider a STEAM career! We greatly appreciate NAB's ongoing
              partnership and support! GoGirlGo4IT is a free 1-day virtual event
              held on 26 Aug; loaded with inspiring speakers & workshops!
            </h5>
            {/* <h6 style={{ marginLeft: "20rem", color: "whitesmoke" }}>
              ~ Brian Kiely
            </h6> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/5.4.jpg"}></img>
          <div style={{ margin: "2rem 0" }}>
            <h5 style={{ color: "whitesmoke" }}>
              Day 1: I have started over in 100DaysOfCode today! I played
              around with my javascript course and my coworker showed me Flexbox
              Froggy. Happy Friday!
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Women;
